"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useEffect } from "react";
export function useWaveAbortController() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const abortControllers = useRef(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = waveId => {
      if (abortControllers.current[waveId]) {
        abortControllers.current[waveId].abort();
        delete abortControllers.current[waveId];
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cancelFetch = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = waveId_0 => {
      cancelFetch(waveId_0);
      const controller = new AbortController();
      abortControllers.current[waveId_0] = controller;
      return controller;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const createController = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (waveId_1, controller_0) => {
      if (abortControllers.current[waveId_1] === controller_0) {
        delete abortControllers.current[waveId_1];
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const cleanupController = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      Object.keys(abortControllers.current).forEach(waveId_2 => {
        cancelFetch(waveId_2);
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const cancelAllFetches = t4;
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => cancelAllFetches;
    t6 = [cancelAllFetches];
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      cancelFetch,
      createController,
      cleanupController,
      cancelAllFetches
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}